export const environment = {
  production: false,
  USER_URL: '/user/',
  ADMIN_URL: '/admin/',
  SAMPLE_WS_URL: 'wss://services.wisium.com/services/api/sample/websocket',
  BAM_URL: 'https://equadvice.wisium.com/event/',
  API_CONTEXT: '/',
  data: {
    apiKey: 'fbf73286-dbd7-46d2-bdc5-f9aa2d7b029e',
    baseUrl: 'https://equadvice.wisium.com/api/data/',
    healthUrl: 'https://equadvice.wisium.com/health/data/health?apikey=fbf73286-dbd7-46d2-bdc5-f9aa2d7b029e'
  },
  identity: {
    apiKey: 'f14b3a37-1d81-40d8-8d05-2ae57b7d0d2d',
    baseUrl: '/services/api/identity/api/',
    healthUrl: 'https://equadvice.wisium.com/services/trusted/identity/health?apikey=f14b3a37-1d81-40d8-8d05-2ae57b7d0d2d'
  },
  technical: {
    apiKey: 'f5fc8764-206d-4621-bd4e-9421460c1832',
    baseUrl: 'https://equadvice.wisium.com/services/api/technical/api/',
    healthUrl: 'https://equadvice.wisium.com/services/trusted/technical/health?apikey=f5fc8764-206d-4621-bd4e-9421460c1832'
  },
  equation: {
    apiKey: 'fe33134c-91d8-42b6-a752-607e369d8a02',
    baseUrl: 'https://equadvice.wisium.com/api/equation/',
    healthUrl: 'https://equadvice.wisium.com/health/equation/health?apikey=fe33134c-91d8-42b6-a752-607e369d8a02'
  },
  equationManager: {
    apiKey: 'ff4f07e1-bf3f-42ab-821f-3ede4e892d15',
    baseUrl: 'https://equadvice.wisium.com/api/equation-manager/',
    healthUrl: 'https://equadvice.wisium.com/health/equation-manager/health?apikey=ff4f07e1-bf3f-42ab-821f-3ede4e892d15'
  },
  sample: {
    apiKey: '0c298940-690d-4100-b757-f4c8be4c352f',
    baseUrl: 'https://equadvice.wisium.com/services/api/sample/',
    healthUrl: 'https://equadvice.wisium.com/services/trusted/sample/health'
  },
  dms: {
    apiKey: 'ea906a9c-8d02-4479-b05e-0f66cd3e12b7',
    baseUrl: 'https://equadvice.wisium.com/services/api/dms/',
    healthUrl: 'https://equadvice.wisium.com/services/trusted/dms/health'
  },
  organization: {
    apiKey: '10dd8b6c-4e6d-42e4-a701-546f5ff9ec99',
    baseUrl: 'https://equadvice.wisium.com/services/api/organization/',
    healthUrl: 'https://equadvice.wisium.com/services/trusted/organization/health'
  },
  GOOGLE_ANALYTICS_TRACKING_ID: 'UA-112233808-9',
  translate: {
    supportedLang: [
      'fr',
      'en',
      'ar',
      'it',
      'es',
      'pt',
      'zh'
    ],
    defaultLang: 'en',
    url: 'https://equadvice.wisium.com/public/i18n'
  },
  multiEditLimit : 200,
  adminEntries: ['nutrients','references','prediction-models','variables','bulletin-templates','sample-groups','matrices']
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.